(ns teamoesterreich.admin-mode.data.ticket
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]

            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))


(defn >add-new [new done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/ticket")
                   (ajax/serialize new)
                   (fn [r-elm status]
                     (log/debug ">add-new-ticket done" r-elm status)
                     (when (< status 300)
                       (done-fn
                         (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elm))))
                         )))))




(defn <get-mine [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/ticket")
                  (fn [r-list status]
                    (log/debug "ticket <get-mine" r-list status)
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "ticket-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                        )))))

(defn <get-by-uuid [uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/ticket/" uuid)
                  (fn [res status]
                    (log/debug "ticket <get done" uuid res status)
                    (when (= status 200)
                      (done-fn
                        (clojure.walk/keywordize-keys (js->clj (json/parse res))))
                        ))))
(defn >set-done [uuid done-fn]
  (ajax/auth-patch> (backend/get-auth) (str backend/BASE_URL "/ticket/" uuid) (ajax/serialize {:ticket-status "done"})
                  (fn [res status]
                    (log/debug "ticket >set done" uuid res status)
                    (when (= status 200)
                      (done-fn
                        (clojure.walk/keywordize-keys (js->clj (json/parse res))))
                        ))))
(defn >set-unsolvable [uuid done-fn]
  (ajax/auth-patch> (backend/get-auth) (str backend/BASE_URL "/ticket/" uuid) (ajax/serialize {:ticket-status "unsolvable"})
                  (fn [res status]
                    (log/debug "ticket >set unsolvable" uuid res status)
                    (when (= status 200)
                      (done-fn
                        (clojure.walk/keywordize-keys (js->clj (json/parse res))))
                        ))))





